import { render, staticRenderFns } from "./FigmaCard.vue?vue&type=template&id=2effd2d0&scoped=true&"
import script from "./FigmaCard.vue?vue&type=script&lang=js&"
export * from "./FigmaCard.vue?vue&type=script&lang=js&"
import style0 from "./FigmaCard.vue?vue&type=style&index=0&id=2effd2d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effd2d0",
  null
  
)

export default component.exports